import React, { useCallback } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import classNames from 'classnames';
import css from './styles.module.scss';
import { Button, TextField, Typography, Divider, Box } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { useForm } from 'react-hook-form';
import { VerticalPopver } from '~/features/dashboard/components/vertical-popover';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { axiosInstance } from '~/api/config/axios.config';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: '100%',
        },
    })
);

interface noteData_props {
    id: number;
    gSongRef: string;
    notes: string;
    completed: number;
    isDelete: number;
}

interface note_props {
    // id : number,
    gSongRef: string;
    notes: string;
    completed: number;
    isDelete: number;
}

interface TODODRAWER_props {
    songId?: string;
    toDoData?: any;
    notesData?: any;
    setNotesData: (data: any) => void;
    setToDosData: (data: any) => void;
}

export const TODODRAWER: React.FC<TODODRAWER_props> = ({ songId, toDoData, notesData, setNotesData, setToDosData }) => {
    const classes = useStyles();
    const [NoteChecked, setNoteChecked] = React.useState([0]);
    const [ToDoChecked, setToDoChecked] = React.useState([0]);
    const [isNewNote, setIsNewNote] = React.useState(false);
    const [isNewToDo, setIsNewToDo] = React.useState(false);
    const [filterNotesData, setFilterNotesData] = React.useState<noteData_props[]>([]);
    const [filterToDoData, setFilterToDosData] = React.useState<noteData_props[]>([]);
    const [isEditNote, setIsEditNote] = React.useState(false);
    const [isEditTodo, setIsEditTodo] = React.useState(false);
    const [editData, setEditData] = React.useState<any>([]);
    const selectedToDOFilter = 0;

    const [mainFilter, setMainFilter] = React.useState(0);

    const handleNoteToggle = (value: number) => () => {
        const currentIndex = NoteChecked.indexOf(value);
        const newChecked = [...NoteChecked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setNoteChecked(newChecked);
    };

    const handleToDoToggle = (value: number) => () => {
        const currentIndex = ToDoChecked.indexOf(value);
        const newChecked = [...ToDoChecked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setToDoChecked(newChecked);
    };

    const ColorButton = withStyles(theme => ({
        root: {
            color: theme.palette.getContrastText('#000'),
            backgroundColor: '#6aca9b',
            '&:hover': {
                backgroundColor: '#6aca9b',
            },
            borderRadius: '8px',
            textTransform: 'capitalize',
        },
    }))(Button);
    const openCreateNote = () => {
        setIsNewNote(true);
    };
    const openCreateToDo = () => {
        setIsNewToDo(true);
    };
    const openEditNote = () => {
        setIsEditNote(true);
    };
    const openEditTodo = () => {
        setIsEditTodo(true);
    };
    React.useEffect(() => {
        setFilterNotesData(notesData);
        setFilterToDosData(toDoData);
    }, [notesData, toDoData]);

    React.useEffect(() => {
        switch (selectedToDOFilter) {
            case 0:
                setFilterToDosData(toDoData);
                break;
            // case 1:
            //     let selectedNotes = toDoData && toDoData.filter((note: any) => note.completed === 1);
            //     setFilterToDosData(selectedNotes);
            //     break;
            // case 2:
            //     let unselectedNotes = toDoData && toDoData.filter((note: any) => note.completed === 0);
            //     setFilterToDosData(unselectedNotes);
            //     break;
            default:
                setFilterToDosData(toDoData);
                break;
        }
    }, [selectedToDOFilter, toDoData]);

    const { handleSubmit, register, getValues } = useForm<noteData_props>();

    const onSubmit = useCallback((data: note_props) => {
        console.log(data);
    }, []);

    const sendToDos = (notes: string, actionFor: string) => {
        let data = {
            gSongRef: songId,
            notes: notes,
            completed: 0,
            isDelete: 0,
        };
        let link = actionFor === 'note' ? 'songnotes' : 'songtodo';

        axiosInstance.post(`/Catalogue/projectCreator/${link}/save`, data).then(res => {
            axiosInstance.get(`/Catalogue/projectcreator/${link}list?gSongRef=${res.data.gSongRef}`).then(resp => {
                if (actionFor === 'note') {
                    setNotesData(resp.data);
                    setIsNewNote(!isNewNote);
                } else {
                    setToDosData(resp.data);
                    setIsNewToDo(!isNewToDo);
                }
            });
        });
    };

    const handleChecked = (completed: Boolean, id: number, notes: string, isDelete: number, actionFor: string) => {
        let data = {
            id: String(id),
            gSongRef: songId,
            notes: notes,
            completed: Number(completed),
            isDelete: isDelete,
        };

        let link = actionFor === 'note' ? 'songnotes' : 'songtodo';

        axiosInstance.post(`/Catalogue/projectCreator/${link}/save`, data).then(res => {
            axiosInstance.get(`/Catalogue/projectcreator/${link}list?gSongRef=${res.data.gSongRef}`).then(resp => {
                setToDosData(resp.data);
            });
            // setIsNewNote(!isNewNote)
        });
    };

    const handleDelete = (completed: number, id: number, notes: string, isDelete: number, actionFor: string) => {
        let data = {
            id: String(id),
            gSongRef: songId,
            notes: notes,
            completed: Number(completed),
            isDelete: 1,
        };

        let link = actionFor === 'note' ? 'songnotes' : 'songtodo';

        axiosInstance.post(`/catalogue/projectCreator/${link}/save`, data).then(res => {
            axiosInstance.get(`/Catalogue/projectcreator/${link}list?gSongRef=${res.data.gSongRef}`).then(resp => {
                if (actionFor === 'note') {
                    setNotesData(resp.data);
                    // setIsNewNote(!isNewNote)
                } else {
                    setToDosData(resp.data);
                    //   setIsNewToDo(!isNewToDo)
                }
            });
        });
    };

    const handleEdit = (completed: number, id: number, notes: string, isDelete: number, actionFor: string) => {
        let data = {
            id: String(id),
            gDealRef: songId,
            notes: notes,
            completed: Number(completed),
            isDelete: 0,
        };

        if (data) {
            setEditData(data);
        }
        // let link = actionFor === 'note' ? 'deal/updateNotes' : 'songs/updateDealTodo';
        if (actionFor === 'note') {
            openEditNote();
        } else {
            openEditTodo();
        }
    };

    const updateToDos = (notes: string, noteid: any, completed: any, actionFor: string) => {
        let data = {
            gSongRef: songId,
            id: noteid,
            notes: notes,
            completed: completed,
            isDelete: 0,
        };

        // console.log(noteid, '=== noticeid');
        let link = actionFor === 'note' ? 'songnotes' : 'songtodo';

        // let link =
        //     actionFor === 'note' ? '/catalogue/projectCreator/songnotes/save' : '/catalogue/projectCreator/songtodo/save';

        axiosInstance.post(`/catalogue/projectCreator/${link}/save`, data).then(res => {
            axiosInstance.get(`/Catalogue/projectcreator/${link}list?gSongRef=${res.data.gSongRef}`).then(resp => {
                if (actionFor === 'note') {
                    setNotesData(resp.data);
                    setIsEditNote(!isEditNote);
                } else {
                    setToDosData(resp.data);
                    setIsEditTodo(!isEditTodo);
                }
            });
        });
    };

    return (
        <>
            <div style={{ padding: '1rem', width: '30vw' }}>
                <Box display="flex" justifyContent="center">
                    <ToggleButtonGroup
                        value={mainFilter}
                        exclusive
                        onChange={(omit, value) => setMainFilter(value)}
                        aria-label="toggle data view"
                        className={css.toggleButtonGroup}
                    >
                        <ToggleButton value={0} aria-label="My Action Points">
                            My Action Points
                        </ToggleButton>
                        <ToggleButton value={1} aria-label="My Notes">
                            My Notes
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Box>
                {mainFilter === 0 && !isEditNote && !isEditTodo && (
                    <div className={css.module} style={{ padding: '1rem' }}>
                        {isNewToDo ? (
                            <>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <h1>Create To Do</h1>
                                    <div>
                                        <ColorButton variant="contained" color="primary" onClick={() => setIsNewToDo(!isNewToDo)}>
                                            Close
                                        </ColorButton>
                                    </div>
                                </div>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <TextField type="number" name={'completed'} inputRef={register({ required: true })} hidden value={0} defaultValue={0} />
                                    <TextField
                                        type="number"
                                        name={'gSongRef'}
                                        hidden
                                        inputRef={register({ required: true })}
                                        value={`${songId}`}
                                        defaultValue={`${songId}`}
                                    />
                                    <TextField
                                        required
                                        fullWidth
                                        inputRef={register({ required: 'Note is required' })}
                                        name="notes"
                                        multiline
                                        variant="filled"
                                        // placeholder={'Type your here.'}
                                        label={'Todo'}
                                        // onChange={(e) => setNewNote(e.target.value)}
                                        // value={newNote}
                                    />
                                    <div style={{ display: 'flex', marginTop: '2rem' }}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            type="submit"
                                            onClick={() => {
                                                sendToDos(getValues('notes'), 'todo');
                                            }}
                                            disableElevation
                                        >
                                            Save
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            disableElevation
                                            style={{ marginLeft: '1rem' }}
                                            onClick={() => setIsNewToDo(!isNewToDo)}
                                        >
                                            Cancel
                                        </Button>
                                    </div>
                                </form>
                            </>
                        ) : (
                            <>
                                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                    <div>
                                        <ColorButton className={css.actionbtn1} variant="contained" color="primary" onClick={() => openCreateToDo()}>
                                            Add Action Point
                                        </ColorButton>
                                    </div>
                                </div>
                                {/* <div className={css.filterSection}>
                                    <Button variant={selectedToDOFilter === 0 ? `contained` : `outlined`} color="secondary" onClick={() => setSelectedToDOFilter(0)} >All</Button>
                                    <Button variant={selectedToDOFilter === 1 ? `contained` : `outlined`} color="secondary" onClick={() => setSelectedToDOFilter(1)}  >Selected</Button>
                                    <Button variant={selectedToDOFilter === 2 ? `contained` : `outlined`} color="secondary" onClick={() => setSelectedToDOFilter(2)}  >Un-Selected</Button>
                                </div> */}
                                {/* {

    mytodoLoading ? '' : */}
                                {filterToDoData.filter(a => a.completed === 0).length > 0 ? <Typography variant="h6">Incompleted</Typography> : <></>}
                                <List className={classNames(classes.root)}>
                                    {filterToDoData
                                        .filter(a => a.completed === 0)
                                        .map(note => {
                                            const labelId = `checkbox-list-label-${note.id}`;

                                            return (
                                                <ListItem
                                                    key={note.id}
                                                    role={undefined}
                                                    dense
                                                    button
                                                    className={css.listRow}
                                                    onClick={handleToDoToggle(note.id)}
                                                    style={{ padding: '0', wordBreak: 'break-word' }}
                                                >
                                                    <ListItemIcon>
                                                        <Checkbox
                                                            edge="start"
                                                            checked={Boolean(note.completed)}
                                                            tabIndex={-1}
                                                            disableRipple
                                                            onChange={() => handleChecked(!Boolean(note.completed), note.id, note.notes, note.isDelete, 'todo')}
                                                            inputProps={{ 'aria-labelledby': labelId }}
                                                        />
                                                    </ListItemIcon>
                                                    <ListItemText id={labelId} primary={`${note.notes}`} />
                                                    <ListItemIcon style={{ flexDirection: 'row-reverse' }}>
                                                        <VerticalPopver
                                                            childClassName={css.deleteIcon}
                                                            actionsList={`edit,delete`}
                                                            onClickDelete={() => handleDelete(note.completed, note.id, note.notes, note.isDelete, 'todo')}
                                                            onClickEdit={() => handleEdit(note.completed, note.id, note.notes, note.isDelete, 'todo')}
                                                        />
                                                    </ListItemIcon>
                                                    {/* <ListItemSecondaryAction>
                                    <IconButton edge="end" aria-label="comments">
                                        <CommentIcon />
                                    </IconButton>
                                </ListItemSecondaryAction> */}
                                                </ListItem>
                                            );
                                        })}
                                </List>

                                {filterToDoData.filter(a => a.completed === 1).length > 0 ? (
                                    <>
                                        <Divider />
                                        <Accordion className={css.accordiancustom}>
                                            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                                                <Typography>Completed</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <List className={classNames(classes.root)} style={{ marginTop: '15px' }}>
                                                    {filterToDoData
                                                        .filter(a => a.completed === 1)
                                                        .map(note => {
                                                            const labelId = `checkbox-list-label-${note.id}`;

                                                            return (
                                                                <ListItem
                                                                    key={note.id}
                                                                    className={css.listRow}
                                                                    role={undefined}
                                                                    dense
                                                                    button
                                                                    onClick={handleToDoToggle(note.id)}
                                                                    style={{ padding: '0', wordBreak: 'break-word' }}
                                                                >
                                                                    <ListItemIcon>
                                                                        <Checkbox
                                                                            edge="start"
                                                                            checked={Boolean(note.completed)}
                                                                            tabIndex={-1}
                                                                            disableRipple
                                                                            onChange={() =>
                                                                                handleChecked(
                                                                                    !Boolean(note.completed),
                                                                                    note.id,
                                                                                    note.notes,
                                                                                    note.isDelete,
                                                                                    'todo'
                                                                                )
                                                                            }
                                                                            inputProps={{ 'aria-labelledby': labelId }}
                                                                        />
                                                                    </ListItemIcon>
                                                                    <ListItemText id={labelId} primary={`${note.notes}`} />
                                                                    <ListItemIcon style={{ flexDirection: 'row-reverse' }}>
                                                                        <VerticalPopver
                                                                            childClassName={css.deleteIcon}
                                                                            actionsList={`edit,delete`}
                                                                            onClickDelete={() =>
                                                                                handleDelete(note.completed, note.id, note.notes, note.isDelete, 'todo')
                                                                            }
                                                                        />
                                                                    </ListItemIcon>
                                                                    {/* <ListItemSecondaryAction>
                                    <IconButton edge="end" aria-label="comments">
                                        <CommentIcon />
                                    </IconButton>
                                </ListItemSecondaryAction> */}
                                                                </ListItem>
                                                            );
                                                        })}
                                                </List>
                                            </AccordionDetails>
                                        </Accordion>
                                    </>
                                ) : (
                                    <></>
                                )}

                                {/* } */}
                            </>
                        )}
                    </div>
                )}
                {/* ///------------------------------------------------------------------------------------------------------------
--------------------------------------------------------------------------------------------------------------------
--------------------------------------------------------------------------------------------------------------------- */}
                {mainFilter === 1 && !isEditNote && !isEditTodo && (
                    <div className={css.module} style={{ padding: '1rem' }}>
                        {isNewNote ? (
                            <>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <h1>Create Note</h1>
                                    <div>
                                        <ColorButton variant="contained" color="primary" onClick={() => setIsNewNote(!isNewNote)}>
                                            Close
                                        </ColorButton>
                                    </div>
                                </div>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <TextField type="number" name={'completed'} inputRef={register({ required: true })} hidden value={0} defaultValue={0} />
                                    <TextField
                                        type="number"
                                        name={'gSongRef'}
                                        hidden
                                        inputRef={register({ required: true })}
                                        value={`${songId}`}
                                        defaultValue={`${songId}`}
                                    />
                                    <TextField
                                        required
                                        fullWidth
                                        inputRef={register({ required: 'Note is required' })}
                                        name="notes"
                                        multiline
                                        variant="filled"
                                        placeholder={'Type your note here.'}
                                        label={'Note'}
                                        // onChange={(e) => setNewNote(e.target.value)}
                                        // value={newNote}
                                    />
                                    <div style={{ display: 'flex', marginTop: '2rem' }}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            type="submit"
                                            onClick={() => {
                                                sendToDos(getValues('notes'), 'note');
                                            }}
                                            disableElevation
                                        >
                                            Save
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            disableElevation
                                            style={{ marginLeft: '1rem' }}
                                            onClick={() => setIsNewNote(!isNewNote)}
                                        >
                                            Cancel
                                        </Button>
                                    </div>
                                </form>
                            </>
                        ) : (
                            <>
                                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                    <div>
                                        <ColorButton variant="contained" color="primary" onClick={() => openCreateNote()}>
                                            Add Notes
                                        </ColorButton>
                                    </div>
                                </div>

                                <List className={classNames(classes.root)}>
                                    {filterNotesData.map(note => {
                                        const labelId = `checkbox-list-label-${note.id}`;

                                        return (
                                            <ListItem
                                                key={note.id}
                                                role={undefined}
                                                className={css.listRow}
                                                dense
                                                button
                                                onClick={handleNoteToggle(note.id)}
                                                style={{ padding: '0', wordBreak: 'break-word' }}
                                            >
                                                <ListItemText id={labelId} primary={`${note.notes}`} />
                                                <ListItemIcon style={{ flexDirection: 'row-reverse' }}>
                                                    {/* <DeleteIcon onClick={() => handleDelete(note.completed,note.id,note.notes,note.isDelete,'note')} /> */}
                                                    <VerticalPopver
                                                        childClassName={css.deleteIcon}
                                                        actionsList={`edit,delete`}
                                                        onClickDelete={() => handleDelete(note.completed, note.id, note.notes, note.isDelete, 'note')}
                                                        onClickEdit={() => handleEdit(note.completed, note.id, note.notes, note.isDelete, 'note')}
                                                    />
                                                </ListItemIcon>
                                                {/* <ListItemSecondaryAction>
                                    <IconButton edge="end" aria-label="comments">
                                        <CommentIcon />
                                    </IconButton>
                                </ListItemSecondaryAction> */}
                                            </ListItem>
                                        );
                                    })}
                                </List>
                                {/* } */}
                            </>
                        )}
                    </div>
                )}

                {isEditNote ? (
                    <>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h1>Edit Note</h1>
                            <div>
                                <ColorButton variant="contained" color="primary" onClick={() => setIsEditNote(!isEditNote)}>
                                    Close
                                </ColorButton>
                            </div>
                        </div>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <TextField
                                type="number"
                                name={'completed'}
                                inputRef={register({ required: true })}
                                hidden
                                value={editData.completed}
                                defaultValue={editData.completed}
                            />
                            <TextField
                                type="number"
                                name={'gDealRef'}
                                hidden
                                inputRef={register({ required: true })}
                                value={`${songId}`}
                                defaultValue={`${songId}`}
                            />
                            <TextField
                                type="number"
                                name={'gNoteid'}
                                hidden
                                inputRef={register({ required: true })}
                                value={`${editData.id}`}
                                defaultValue={`${editData.id}`}
                            />
                            <TextField
                                required
                                fullWidth
                                inputRef={register({ required: 'Note is required' })}
                                name="notes"
                                multiline
                                variant="filled"
                                placeholder={'Type your note here.'}
                                label={'Note'}
                                // onChange={(e) => setNewNote(e.target.value)}
                                defaultValue={editData.notes}
                            />
                            <div style={{ display: 'flex', marginTop: '2rem' }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                    onClick={() => {
                                        updateToDos(getValues('notes'), getValues('gNoteid'), getValues('completed'), 'note');
                                    }}
                                    disableElevation
                                >
                                    Update
                                </Button>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    disableElevation
                                    style={{ marginLeft: '1rem' }}
                                    onClick={() => setIsEditNote(!isEditNote)}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </form>
                    </>
                ) : (
                    ``
                )}

                {isEditTodo ? (
                    <>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h1>Edit Todo</h1>
                            <div>
                                <ColorButton variant="contained" color="primary" onClick={() => setIsEditTodo(!isEditTodo)}>
                                    Close
                                </ColorButton>
                            </div>
                        </div>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <TextField
                                type="number"
                                name={'completed'}
                                inputRef={register({ required: true })}
                                hidden
                                value={editData.completed}
                                defaultValue={editData.completed}
                            />
                            <TextField
                                type="number"
                                name={'gDealRef'}
                                hidden
                                inputRef={register({ required: true })}
                                value={`${songId}`}
                                defaultValue={`${songId}`}
                            />
                            <TextField
                                type="number"
                                name={'gNoteid'}
                                hidden
                                inputRef={register({ required: true })}
                                value={`${editData.id}`}
                                defaultValue={`${editData.id}`}
                            />
                            <TextField
                                required
                                fullWidth
                                inputRef={register({ required: 'Note is required' })}
                                name="notes"
                                multiline
                                variant="filled"
                                placeholder={'Type your note here.'}
                                label={'Note'}
                                // onChange={(e) => setNewNote(e.target.value)}
                                defaultValue={editData.notes}
                            />
                            <div style={{ display: 'flex', marginTop: '2rem' }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                    onClick={() => {
                                        updateToDos(getValues('notes'), getValues('gNoteid'), getValues('completed'), 'action');
                                    }}
                                    disableElevation
                                >
                                    Update
                                </Button>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    disableElevation
                                    style={{ marginLeft: '1rem' }}
                                    onClick={() => setIsEditTodo(!isEditTodo)}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </form>
                    </>
                ) : (
                    ``
                )}
            </div>
        </>
    );
};
